import { useCallback } from 'react';
import appUpdateService from '../services/AppUpdateService';

/**
 * Hook für App-Update-Funktionalitäten
 */
export const useAppUpdate = () => {
    /**
     * Manuelle Überprüfung auf App-Updates
     */
    const checkForUpdate = useCallback(async () => {
        try {
            return await appUpdateService.checkForUpdateManually();
        } catch (error) {
            console.error('Error checking for app update:', error);
            throw error;
        }
    }, []);

    /**
     * Abrufen der aktuellen App-Informationen
     */
    const getAppInfo = useCallback(async () => {
        try {
            return await appUpdateService.getAppInfo();
        } catch (error) {
            console.error('Error getting app info:', error);
            throw error;
        }
    }, []);

    /**
     * Öffnet den App Store direkt
     */
    const openAppStore = useCallback(async () => {
        try {
            await appUpdateService.openAppStore();
        } catch (error) {
            console.error('Error opening app store:', error);
            throw error;
        }
    }, []);

    /**
     * Setzt alle Update-Einstellungen zurück
     */
    const resetUpdateSettings = useCallback(() => {
        try {
            appUpdateService.resetUpdateSettings();
        } catch (error) {
            console.error('Error resetting update settings:', error);
            throw error;
        }
    }, []);

    /**
     * Gibt Update-Statistiken zurück
     */
    const getUpdateStats = useCallback(() => {
        try {
            return appUpdateService.getUpdateStats();
        } catch (error) {
            console.error('Error getting update stats:', error);
            throw error;
        }
    }, []);

    return {
        checkForUpdate,
        getAppInfo,
        openAppStore,
        resetUpdateSettings,
        getUpdateStats
    };
};

export default useAppUpdate;
